module.exports = __webpack_public_path__ + "img/BigWaterfall.d8cabda4.jpg";